// import 'ses'
// import '../core/lockdown'
import * as THREE from 'three'
import { useEffect, useMemo, useRef, useState } from 'react'
import { css } from '@firebolt-dev/css'

import { createClientWorld } from '../core/createClientWorld'
import { CoreUI } from './components/CoreUI'
import { attachVoiceService } from './voice-service'
import { initArtMode } from './art-mode'

export { System } from '../core/systems/System'

export function Client({ wsUrl, assetsUrl, onSetup }) {
  const viewportRef = useRef()
  const uiRef = useRef()
  const world = useMemo(() => {
    const created = createClientWorld()
    // Арт-режим оболочки: браузерная версия идёт в аниме, реал ждёт Steam.
    initArtMode()
    // Обработка микрофона живёт на весь сеанс, а не на время экрана:
    // настроил и играешь — очистка остаётся.
    attachVoiceService(created)
    return created
  }, [])
  const [ui, setUI] = useState(world.ui.state)
  useEffect(() => {
    world.on('ui', setUI)
    return () => {
      world.off('ui', setUI)
    }
  }, [])
  useEffect(() => {
    const init = async () => {
      const viewport = viewportRef.current
      const ui = uiRef.current
      const baseEnvironment = {
        model: '/base-environment.glb',
        bg: null, // '/day2-2k.jpg',
        hdr: '/Clear_08_4pm_LDR.hdr',
        rotationY: 0,
        sunDirection: new THREE.Vector3(-1, -2, -2).normalize(),
        sunIntensity: 1,
        sunColor: 0xffffff,
        fogNear: null,
        fogFar: null,
        fogColor: null,
      }
      if (typeof wsUrl === 'function') {
        wsUrl = wsUrl()
        if (wsUrl instanceof Promise) wsUrl = await wsUrl
      }
      if (typeof assetsUrl === 'function') {
        assetsUrl = assetsUrl()
        if (assetsUrl instanceof Promise) assetsUrl = await assetsUrl
      }
      const config = { viewport, ui, wsUrl, assetsUrl, baseEnvironment }
      onSetup?.(world, config)
      world.init(config)
    }
    init()
  }, [])
  return (
    <div
      className='App'
      css={css`
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100dvh;
        overflow: clip;
        .App__viewport {
          position: absolute;
          inset: 0;
          overflow: clip;
        }
        .App__ui {
          position: absolute;
          inset: 0;
          overflow: clip;
          pointer-events: none;
          user-select: none;
          display: ${ui.visible ? 'block' : 'none'};
        }
      `}
    >
      <div className='App__viewport' ref={viewportRef}>
        <div className='App__ui' ref={uiRef}>
          <CoreUI world={world} />
        </div>
      </div>
    </div>
  )
}
